"use client";
import { countBreadcrumbs } from "@/helpers/common";
import { TArticlePage } from "@/components/pages/translations/TArticlePage";
import { ArticleSinglePageContext } from "@/helpers/contexts/ArticleSinglePageContext";
import "@/styles/critical/_article-header.scss";

export const TranslationsArticlePage = ({ translation, breadcrumbsList, isPreview, translationId }: any) => (
  <ArticleSinglePageContext.Provider
    value={{
      categoriesWithSubcategories: [],
      article: translation as any,
      breadcrumbsList: countBreadcrumbs(breadcrumbsList),
      isPreview,
      pageId: translationId,
      config: null,
    }}
  >
    <TArticlePage key={translation.slug} />
  </ArticleSinglePageContext.Provider>
);
